
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";
import { LocationFormValues } from "./types";

type CityFieldProps = {
  control: Control<LocationFormValues>;
};

const CityField = ({ control }: CityFieldProps) => {
  if (!control) {
    console.error("Form control is missing in CityField");
    return null;
  }
  
  return (
    <FormField
      control={control}
      name="city"
      render={({ field }) => (
        <FormItem>
          <FormLabel>City</FormLabel>
          <FormControl>
            <Input placeholder="Your city" {...field} value={field.value || ""} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default CityField;
